import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LabGeoContainer from 'containers/labs/LabGeoContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
// import { setTimeRangeByKey, timeRanges } from 'services/config/duck';
// import { getTimeRangeForUri } from 'services/config/selectors';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';

const LabGeoDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)} hideDatePicker />}>

        <DetermineLayerContainer
            layerTwo={LabGeoContainer}
            layerThree={LabGeoContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(),
    PageTitle({ pageTitle: 'Labs - Geo Analysis' }),
    PageView({ page: 'Viewed Entity Display', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            // range: {
            //     selector: getTimeRangeForUri,
            //     action: (value) => {
            //         // Break, Check if range is KEY of default sets (i.e. last-30-days)
            //         if (Object.keys(timeRanges).indexOf(value) > -1) {
            //             return setTimeRangeByKey(value);
            //         }

            //         return { type: 'NOOP', payload: 'LabGeoDashboard(range)' };
            //     }
            // }
        },
        initialTruth: 'location',
    })
)(LabGeoDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/labs/LabGeo.js